import React from 'react';
import { getUserInitials, getUserDisplayName } from '../utils/userUtils';
import './Header.css';

const Header = ({ user }) => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <img src="/images/logo-gradient.svg" alt="Logo" className="logo-gradient" />
          <span className="logo-divider"></span>
          <span className="logo-text">Language Buddy</span>
        </div>

        <div className="header-right">
          <div className="user-avatar" title={getUserDisplayName(user)}>
            {getUserInitials(user)}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
